import Vue from 'vue'
import VueRouter from 'vue-router'
import { ROUTE_NAME } from '@/constants/route.constants'

// Must not be dynamically imported like the other routes as some global styles reside in here.
import Home from '@/views/Home.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      redirect: '/'
    },
    {
      path: '/',
      name: ROUTE_NAME.HOME,
      meta: { layout: 'layout' },
      component: Home
    },
    {
      path: '/article',
      name: ROUTE_NAME.ARTICLE,
      meta: { layout: 'layout' },
      component: () => import('@/views/Article/Article.vue')
    },
    {
      path: '/article-detail/:articleId',
      name: ROUTE_NAME.ARTICLE_DETAIL,
      meta: { layout: 'layout' },
      component: () => import('@/views/Article/ArticleDetail.vue')
    },
    {
      path: '/product',
      component: () => import('@/views/Product/Product.vue'),
      children: [
        {
          path: 'category/:category',
          name: ROUTE_NAME.PRODUCT_CATEGORY,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/CategoryProducts.vue')
        },
        {
          path: 'flash-deals',
          name: ROUTE_NAME.PRODUCT_FLASH_DEALS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/FlashDeals.vue')
        },
        {
          path: 'hot-deals',
          name: ROUTE_NAME.PRODUCT_HOT_DEALS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/HotDeals.vue')
        },
        {
          path: 'best-seller/:topPickImageId',
          name: ROUTE_NAME.PRODUCT_BEST_SELLER,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/BestSeller.vue')
        },
        {
          path: 'detail/:productId',
          name: ROUTE_NAME.PRODUCT_DETAIL,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/Detail.vue')
        },
        {
          path: 'wish-list',
          name: ROUTE_NAME.PRODUCT_WISH_LIST,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/WishList.vue')
        },
        {
          path: 'agent-deals',
          name: ROUTE_NAME.PRODUCT_AGENT_DEALS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/AgentDeals.vue')
        },
        {
          path: ':searchName',
          name: ROUTE_NAME.PRODUCT_SEARCH,
          meta: { layout: 'layout' },
          component: () => import('@/views/Product/Search.vue')
        }
      ]
    },
    {
      path: '/order',
      component: () => import('@/views/Order/Order.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.ORDER_DASHBOARD,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/Dashboard.vue')
        },
        {
          path: 'list/:id',
          name: ROUTE_NAME.ORDER_LIST,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/List.vue')
        },
        {
          path: 'cart',
          name: ROUTE_NAME.ORDER_CART,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/Cart.vue')
        },
        {
          path: 'check-out',
          name: ROUTE_NAME.ORDER_CHECK_OUT,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Order/CheckOut.vue')
        },
        {
          path: 'delivery/:id',
          name: ROUTE_NAME.ORDER_DELIVERY,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/Delivery.vue')
        },
        {
          path: 'detail/:poNumber',
          name: ROUTE_NAME.ORDER_DETAIL,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Order/Detail.vue')
        },
        {
          path: 'refund/:order_id/:product_id',
          name: ROUTE_NAME.ORDER_REFUND,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Order/Refund.vue')
        },
        {
          path: 'return-pickup',
          name: ROUTE_NAME.ORDER_RETURN_PICKUP,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/ReturnPickUp.vue')
        },
        {
          path: 'return-pickup-address',
          name: ROUTE_NAME.ORDER_RETURN_PICKUP_ADDRESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/PickUpAddressBook.vue')
        },
        {
          path: 'address-book',
          name: ROUTE_NAME.ORDER_ADDRESS_BOOK,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Order/AddressBook.vue')
        },
        {
          path: 'add-address',
          name: ROUTE_NAME.ORDER_ADD_ADDRESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/AddAddress.vue')
        },
        {
          path: 'edit-address/:addressId',
          name: ROUTE_NAME.ORDER_EDIT_ADDRESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/EditAddress.vue')
        },
        {
          path: 'payment-success',
          name: ROUTE_NAME.ORDER_PAYMENT_SUCCESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/PaymentSuccess.vue')
        },
        {
          path: 'pay/:poNumber',
          name: ROUTE_NAME.ORDER_PAYMENT,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Order/Payment.vue')
        }
      ]
    },
    {
      path: '/appointment',
      component: () => import('@/views/Appointment/Appointment.vue'),
      children: [
        {
          path: 'new',
          name: ROUTE_NAME.APPOINTMENT_MAKE_APPOINTMENT,
          meta: { layout: 'layout' },
          component: () => import('@/views/Appointment/MakeAppointment.vue'),
          props: true
        },
        {
          path: 'my-appointment',
          name: ROUTE_NAME.APPOINTMENT_MY_APPOINTMENT,
          meta: { layout: 'layout' },
          component: () => import('@/views/Appointment/MyAppointment.vue')
        },
        {
          path: 'detail/:id',
          name: ROUTE_NAME.APPOINTMENT_DETAIL,
          meta: { layout: 'layout' },
          component: () => import('@/views/Appointment/Detail.vue'),
          props: true
        },
        {
          path: 'edit/:bookingId',
          name: ROUTE_NAME.APPOINTMENT_EDIT_APPOINTMENT,
          meta: { layout: 'layout' },
          component: () => import('@/views/Appointment/MakeAppointment.vue'),
          props: true
        },
        {
          path: 'complete',
          name: ROUTE_NAME.APPOINTMENT_COMPLETE,
          component: () => import('@/views/Appointment/MakeAppointmentComplete.vue')
        }
      ]
    },
    {
      path: '/agent',
      component: () => import('@/views/Agent/Agent.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.AGENT_DASHBOARD,
          meta: { layout: 'layout' },
          component: () => import('@/views/Agent/Dashboard.vue')
        },
        {
          path: 'member-transaction-history/:memberId',
          name: ROUTE_NAME.MEMBER_TRANSACTION_HISTORY,
          meta: { layout: 'layout' },
          component: () => import('@/views/Agent/MemberTransactionHistory.vue')
        },
        {
          path: 'convert-point',
          name: ROUTE_NAME.AGENT_CONVERT_POINT,
          meta: { layout: 'layout' },
          component: () => import('@/views/Agent/ConvertPoint.vue')
        },
        {
          path: 'convert-point/complete',
          name: ROUTE_NAME.AGENT_CONVERT_POINT_COMPLETE,
          meta: { layout: 'layout' },
          component: () => import('@/views/Agent/ConvertPointAcknowledgement.vue')
        },
        {
          path: 'transfer-to-bank',
          name: ROUTE_NAME.AGENT_TRANSFER_TO_BANK,
          component: () => import('@/views/Agent/TransferToBank.vue')
        },
        {
          path: 'add-bank-account',
          name: ROUTE_NAME.AGENT_ADD_BANK_ACCOUNT,
          component: () => import('@/views/Agent/AddBankAccount.vue')
        },
        {
          path: 'one-time-transfer',
          name: ROUTE_NAME.AGENT_ONE_TIME_TRANSFER,
          component: () => import('@/views/Agent/OneTimeTransfer.vue')
        },
        {
          path: 'transfer-to-bank/complete',
          name: ROUTE_NAME.AGENT_TRANSFER_TO_BANK_COMPLETE,
          component: () => import('@/views/Agent/TransferToBankAcknowledgement.vue')
        }
      ]
    },
    // {
    //   path: '/voucher',
    //   component: () => import('@/views/Vouchers/Vouchers.vue'),
    //   children: [
    //     {
    //       path: '',
    //       name: ROUTE_NAME.VOUCHER,
    //       meta: { layout: 'layout' },
    //       component: () => import('@/views/Vouchers/VouchersListing.vue')
    //     },
    //     {
    //       path: 'details/:productId',
    //       name: ROUTE_NAME.VOUCHER_DETAILS,
    //       meta: { layout: 'layout' },
    //       component: () => import('@/views/Vouchers/VouchersDetails.vue')
    //     }
    //   ]
    // },
    {
      path: '/salon',
      component: () => import('@/views/SalonInfo/SalonInfo.vue'),
      children: [
        {
          path: 'list',
          name: ROUTE_NAME.SALON_INFO_LIST,
          meta: { layout: 'layout' },
          component: () => import('@/views/SalonInfo/SalonInfoListing.vue')
        },
        {
          path: 'review/:salonId',
          name: ROUTE_NAME.SALON_REVIEW,
          meta: { layout: 'layout' },
          component: () => import('@/views/SalonInfo/SalonInfoReview.vue')
        }
      ]
    },
    {
      path: '/product-review',
      meta: { layout: 'layout' },
      component: () => import('@/views/Review/ProductReview.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.PRODUCT_REVIEW,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Review/ProductReviewList.vue')
        },
        {
          path: 'write-review',
          name: ROUTE_NAME.PRODUCT_REVIEW_WRITE,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Review/ProductReviewWrite.vue')
        }
      ]
    },
    {
      path: '/salon-review',
      meta: { layout: 'layout' },
      component: () => import('@/views/Review/SalonStylistReview.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.SALON_STYLIST_REVIEW_LIST,
          meta: { layout: 'layout' },
          component: () => import('@/views/Review/SalonStylistReviewList.vue')
        },
        {
          path: 'review/:posTransactionId',
          name: ROUTE_NAME.SALON_STYLIST_REVIEW_NEW,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Review/SalonStylistReviewPrompt.vue')
        },
        {
          path: 'write-reviews/:posTransactionId',
          name: ROUTE_NAME.SALON_STYLIST_REVIEW_WRITE,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Review/SalonStylistReviewContainer.vue')
        },
        {
          path: 'complete',
          name: ROUTE_NAME.SALON_STYLIST_REVIEW_COMPLETE,
          meta: { layout: 'layout' },
          component: () => import('@/views/Review/SalonStylistReviewComplete.vue')
        }
      ]
    },
    {
      path: '/terms-of-service',
      name: ROUTE_NAME.TERMS_OF_SERVICE,
      meta: { layout: 'plain-layout' },
      component: () => import('@/views/TermsOfService.vue')
    },
    {
      path: '/agent-terms-of-service',
      name: ROUTE_NAME.AGENT_TERMS_OF_SERVICE,
      meta: { layout: 'plain-layout' },
      component: () => import('@/views/AgentTermsOfService.vue')
    },
    {
      path: '/privacy-policy',
      name: ROUTE_NAME.PRIVACY_POLICY,
      meta: { layout: 'plain-layout' },
      component: () => import('@/views/PrivacyPolicy.vue')
    },
    {
      path: '/profile',
      component: () => import('@/views/Profile/Profile.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.PROFILE,
          meta: { layout: 'layout' },
          component: () => import('@/views/Profile/Index.vue')
        },
        {
          path: 'address-book',
          name: ROUTE_NAME.PROFILE_ADDRESS_BOOK,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/AddressBook.vue')
        },
        {
          path: 'add-address',
          name: ROUTE_NAME.PROFILE_ADD_ADDRESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/AddAddress.vue')
        },
        {
          path: 'edit-address/:addressId',
          name: ROUTE_NAME.PROFILE_EDIT_ADDRESS,
          meta: { layout: 'layout' },
          component: () => import('@/views/Order/EditAddress.vue')
        }
      ]
    },
    {
      path: '/wallet',
      meta: { layout: 'layout' },
      component: () => import('@/views/Wallet/Wallet.vue'),
      children: [
        {
          path: '',
          name: ROUTE_NAME.WALLET,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Wallet/WalletDetails.vue')
        },
        {
          path: '/voucher-detail/:id',
          name: ROUTE_NAME.WALLET_VOUCHER_DETAILS,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Wallet/VoucherDetails.vue')
        },
        {
          path: '/point-transfer',
          name: ROUTE_NAME.WALLET_POINT_TRANSFER,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Wallet/PointTransfer.vue')
        },
        {
          path: '/point-transfer/complete',
          name: ROUTE_NAME.WALLET_POINT_TRANSFER_COMPLETE,
          meta: { layout: 'layout' },
          props: true,
          component: () => import('@/views/Wallet/PointTransferAcknowledgement.vue')
        }
      ]
    },
    {
      path: '*',
      meta: { layout: 'plain-layout' },
      component: () => import('@/views/errors/404.vue')
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
